// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"437937dba8979248d315efc386bd83feadeeb49c"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/storefront/437937dba8979248d315efc386bd83feadeeb49c";import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';

import { filterSentrySpan } from '@utils/sentryFilters';
import { tagBotTraffic } from '@utils/sentryTags';

const envVars = getConfig().publicRuntimeConfig;

Sentry.init({
  dsn: envVars.SENTRY_DSN || '',
  release: envVars.SENTRY_RELEASE || '',
  tracesSampleRate: 0.05,
  debug: false,
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['storefront'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  beforeSendSpan: filterSentrySpan,
});

tagBotTraffic(navigator.userAgent);
